(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-library"] && !Shopify.designMode) return;
  try {
    
// Search uses only storefront-rendered catalog cards, never private Drive records.
function jiuLibraryRoots(root) {
  return [...(root.matches && root.matches('[data-print-library]') ? [root] : []), ...root.querySelectorAll('[data-print-library]')];
}
function initializeJiuLibrary(root) {
  jiuLibraryRoots(root).forEach((library) => {
    if (library._jiuApplyFilter) { library._jiuApplyFilter(); return; }
    const search = library.querySelector('[data-print-search]');
    const colorSelect = library.querySelector('[data-color-filter]');
    const grid = library.querySelector('.jiu-library__grid');
    if (!search || !grid) return;
    // Articles also have data-category. Only actual sidebar buttons are controls.
    const buttons = [...library.querySelectorAll('.jiu-library__filters button[data-category]')];
    const subWrap = library.querySelector('[data-subcategories]');
    const subList = library.querySelector('[data-subcategory-list]');
    const noResults = library.querySelector('[data-no-results]');
    const count = library.querySelector('[data-result-count]');
    const coverage = library.querySelector('[data-search-coverage]');
    const retry = library.querySelector('[data-search-retry]');
    const pageInfo = library.querySelector('[data-library-pagination]');
    const nav = library.querySelector('.jiu-pagination:not([data-client-pagination])');
    const totalPages = Math.max(1, Number(pageInfo && pageInfo.dataset.pages) || 1);
    const currentPage = Number(pageInfo && pageInfo.dataset.page) || 1;
    const loadedPages = new Set([currentPage]);
    const knownIds = new Set();
    const index = [];
    const normalize = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const addCard = (card) => {
      const id = card.dataset.printId;
      if (!id || knownIds.has(id)) return false;
      knownIds.add(id);
      const addedAt = Date.parse(card.dataset.addedAt || '');
      index.push({ card, text: normalize(card.dataset.search), id: normalize(id).replace(/ /g, ''), tags: (card.dataset.tags || '').split('||').map(normalize), addedAt: Number.isFinite(addedAt) ? addedAt : 0, randomKey: Math.random() });
      return true;
    };
    grid.querySelectorAll('[data-print-card]').forEach(addCard);
    let category = 'all', subcategory = 'all', loading = false, failed = false, loadPromise = null, timer, randomized = false;
    const complete = () => loadedPages.size >= totalPages;
    const text = (key, fallback) => library.dataset[key] || fallback;
    const recentWindowMs = 30 * 24 * 60 * 60 * 1000;
    const isRecent = (addedAt) => addedAt > 0 && (Date.now() - addedAt) >= 0 && (Date.now() - addedAt) <= recentWindowMs;
    const activate = (items, value, attr) => items.forEach((button) => {
      const active = button.getAttribute(attr) === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const buildSubs = () => {
      if (!subWrap || !subList) return;
      subList.replaceChildren();
      subWrap.hidden = category === 'all' || category === 'recently-added';
      if (category === 'all' || category === 'recently-added') return;
      const values = new Map();
      index.forEach(({card}) => { if (card.dataset.category === category && card.dataset.subcategory) values.set(card.dataset.subcategory, card.dataset.subcategoryLabel || card.dataset.subcategory); });
      const add = (value, label) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'jiu-filter-link';
        button.dataset.subcategory = value; button.textContent = label;
        subList.appendChild(button);
      };
      add('all', text('allSubcategories', 'All in this category'));
      [...values].sort((a,b) => a[1].localeCompare(b[1])).forEach(([value,label]) => add(value,label));
      activate([...subList.children], subcategory, 'data-subcategory');
    };
    let pageSize=100;let resultPage=1;const pageSizeSelect=library.querySelector('[data-page-size]');const clientNav=library.querySelector('[data-client-pagination]');const renderClientPagination=(total)=>{if(!clientNav)return;const pages=Math.max(1,Math.ceil(total/pageSize));if(resultPage>pages)resultPage=pages;clientNav.replaceChildren();clientNav.hidden=pages<=1;if(pages<=1)return;const make=(label,page,disabled=false,current=false)=>{const b=document.createElement('button');b.type='button';b.textContent=label;b.className='jiu-pagination__button'+(current?' is-current':'');b.disabled=disabled;if(current)b.setAttribute('aria-current','page');b.addEventListener('click',()=>{resultPage=page;filter();library.querySelector('.jiu-library__results')?.scrollIntoView({behavior:'smooth',block:'start'});});clientNav.appendChild(b);};make('‹',Math.max(1,resultPage-1),resultPage===1);for(let p=1;p<=pages;p++)make(String(p),p,false,p===resultPage);make('›',Math.min(pages,resultPage+1),resultPage===pages);};if(pageSizeSelect){pageSize=Number(pageSizeSelect.value)||100;pageSizeSelect.addEventListener('change',()=>{pageSize=Number(pageSizeSelect.value)||100;resultPage=1;filter();});}const filter = () => {
      const query = normalize(search.value);
      const tokens = query.split(' ').filter(Boolean);
      const compact = query.replace(/ /g, '');
      const color = normalize(colorSelect ? colorSelect.value : 'all');
      let visible = 0;
      index.forEach(({card, text: haystack, id, tags, addedAt}) => {
        const match = !tokens.length || tokens.every((token) => haystack.includes(token)) || (/^(?:jiu|char|\d)/.test(compact) && id.includes(compact));
        const categoryMatch = category === 'all' || (category === 'recently-added' ? isRecent(addedAt) : card.dataset.category === category);
        const show = match && categoryMatch && (subcategory === 'all' || card.dataset.subcategory === subcategory) && (color === 'all' || tags.some((tag) => tag.split(' ').includes(color)));
        card.hidden = !show;
        if (show) visible++;
      });
      const firstResult=(resultPage-1)*pageSize;const lastResult=firstResult+pageSize;let matchIndex=0;index.forEach(({card})=>{if(!card.hidden){const onPage=matchIndex>=firstResult&&matchIndex<lastResult;card.hidden=!onPage;matchIndex++;}});renderClientPagination(visible);if(count){const shown=Math.max(0,Math.min(pageSize,visible-firstResult));count.textContent=complete()?(shown+' of '+visible+' matching designs showing'):(shown+' designs showing · '+index.length+' loaded so far');}
      if (noResults) noResults.hidden = visible !== 0 || loading || (failed && !complete());
      buttons.forEach((button) => {
        const value = button.dataset.category;
        const hasResults = value === 'all' || (value === 'recently-added' ? index.some(({addedAt}) => isRecent(addedAt)) : index.some(({card}) => card.dataset.category === value));
        button.disabled = complete() && !hasResults;
      });
      activate(buttons, category, 'data-category');
      if (nav) nav.hidden = true;
      grid.setAttribute('aria-busy', String(loading));
      if (coverage) {
        coverage.hidden = complete();
        coverage.textContent = loading ? text('searchLoading', 'Loading the rest of the print library…') : failed ? text('searchPartial', 'Some library pages could not load. Results cover loaded designs only.') : text('searchScope', 'The remaining library pages will load automatically.');
      }
      if (retry) retry.hidden = !failed || loading || complete();
    };
    const shuffleGrid = () => {
      index.sort((a,b) => a.randomKey - b.randomKey);
      const fragment = document.createDocumentFragment();
      index.forEach(({card}) => fragment.appendChild(card));
      grid.appendChild(fragment);
    };
    const maybeRandomize = () => {
      if (!randomized && complete()) {
        randomized = true;
        shuffleGrid();
      }
    };
    const loadCatalog = () => {
      if (complete() || loadPromise) return loadPromise;
      if (!pageInfo || !pageInfo.dataset.sectionId || totalPages > 100) { failed = true; filter(); return; }
      loading = true; failed = false; filter();
      const pending = Array.from({length:totalPages},(_,i)=>i+1).filter((page)=>!loadedPages.has(page));
      const worker = async () => {
        while (pending.length && !failed && library.isConnected) {
          const page = pending.shift();
          const controller = new AbortController();
          const timeout = setTimeout(()=>controller.abort(),12000);
          try {
            // Keep current locale, preview-theme context, and all unrelated URL parameters.
            const url = new URL(window.location.href);
            url.searchParams.delete('sections');
            url.searchParams.set('section_id',pageInfo.dataset.sectionId);
            url.searchParams.set(pageInfo.dataset.pageParam || 'page',String(page));
            const response = await fetch(url.toString(),{credentials:'same-origin',signal:controller.signal,headers:{Accept:'text/html'}});
            if (!response.ok) throw new Error('SECTION_LOAD_FAILED');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const remote = [...doc.querySelectorAll('[data-library-pagination]')].find((item)=>item.dataset.sectionId===pageInfo.dataset.sectionId);
            if (!remote || Number(remote.dataset.page)!==page || Number(remote.dataset.pages)!==totalPages) throw new Error('SECTION_PAGE_MISMATCH');
            const source = remote.closest('[data-print-library]');
            if (!source || !library.isConnected) throw new Error('SECTION_MISSING');
            const fragment = document.createDocumentFragment();
            source.querySelectorAll('[data-print-card]').forEach((card)=>{if(addCard(card))fragment.appendChild(card);});
            grid.appendChild(fragment);
            loadedPages.add(page); maybeRandomize(); buildSubs(); filter();
          } catch (error) { failed = true; }
          finally { clearTimeout(timeout); }
        }
      };
      // Bounded section reads, not a separate request for every keystroke.
      loadPromise = Promise.all([worker(),worker()]).finally(()=>{loading=false;loadPromise=null;filter();});
      return loadPromise;
    };
    const searchChanged = () => { resultPage=1; filter(); clearTimeout(timer); if(normalize(search.value))timer=setTimeout(loadCatalog,150); };
    search.addEventListener('input',searchChanged);
    search.addEventListener('search',searchChanged);
    search.addEventListener('change',searchChanged);
    search.addEventListener('keydown',(event)=>{if(event.key==='Enter'){event.preventDefault();filter();loadCatalog();}});
    buttons.forEach((button)=>button.addEventListener('click',()=>{category=button.dataset.category;subcategory='all';resultPage=1;buildSubs();filter();loadCatalog();}));
    if(subList)subList.addEventListener('click',(event)=>{const button=event.target.closest('button[data-subcategory]');if(!button)return;subcategory=button.dataset.subcategory;resultPage=1;activate([...subList.children],subcategory,'data-subcategory');filter();loadCatalog();});
    if(colorSelect)colorSelect.addEventListener('change',()=>{resultPage=1;filter();loadCatalog();});
    const clear=library.querySelector('[data-clear]');
    if(clear)clear.addEventListener('click',()=>{category='all';subcategory='all';resultPage=1;search.value='';if(colorSelect)colorSelect.value='all';buildSubs();filter();loadCatalog();});
    if(retry)retry.addEventListener('click',loadCatalog);
    library._jiuApplyFilter=filter;
    library.dataset.initialized='native-pages-v4';
    maybeRandomize();buildSubs();filter();
    // All prints must finish loading even when no search or filter is selected.
    loadCatalog();
  });
}
function initializeJiuPreview(root){jiuLibraryRoots(root).forEach((library)=>{if(library.dataset.previewInitialized)return;library.dataset.previewInitialized='true';const dialog=library.querySelector('[data-preview-dialog]');if(!dialog)return;const preview=dialog.querySelector('[data-blanket-preview]');const viewport=dialog.querySelector('[data-preview-viewport]');const zoomOut=dialog.querySelector('[data-preview-zoom-out]');const zoomIn=dialog.querySelector('[data-preview-zoom-in]');const zoomReset=dialog.querySelector('[data-preview-zoom-reset]');const zoomLevel=dialog.querySelector('[data-preview-zoom-level]');const nameEl=dialog.querySelector('[data-preview-name]');const idEl=dialog.querySelector('[data-preview-id]');const scaleInput=dialog.querySelector('[data-scale-input]');const scaleOutput=dialog.querySelector('[data-scale-output]');const summary=dialog.querySelector('[data-selected-summary]');const status=dialog.querySelector('[data-cart-status]');const addButton=dialog.querySelector('[data-add-blanket]');const closeButton=dialog.querySelector('[data-preview-close]');const sizeButtons=Array.from(dialog.querySelectorAll('[data-size-option]'));const scales=[8,10,12,14,16,18,20,22,24,26,28,30];const labels=(dialog.dataset.scaleLabels||'').split('|');let current={printId:'',printName:'',previewUrl:''};let sizeButton=sizeButtons[0];let scaleIndex=3;let zoom=1;const rootUrl=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';const selectedScale=()=>({inches:scales[scaleIndex],label:labels[scaleIndex]||String(scales[scaleIndex])});const paintZoom=()=>{if(!preview)return;preview.style.transform='scale('+zoom+')';if(zoomLevel)zoomLevel.textContent=Math.round(zoom*100)+'%';if(zoomOut)zoomOut.disabled=zoom<=1;if(zoomIn)zoomIn.disabled=zoom>=3;if(zoomReset)zoomReset.disabled=zoom===1};const paint=()=>{if(!sizeButton||!preview)return;const width=Number(sizeButton.dataset.width)||50;const height=Number(sizeButton.dataset.height)||60;const scale=selectedScale();if(viewport)viewport.style.aspectRatio=width+'/'+height;preview.style.backgroundImage=current.previewUrl?'url("'+current.previewUrl.replace(/"/g,'%22')+'")':'none';preview.style.backgroundSize=((scale.inches/width)*100)+'% auto';preview.setAttribute('aria-label',(dialog.dataset.previewAria||'').replace('[name]',current.printName).replace('[size]',sizeButton.dataset.label||'').replace('[scale]',scale.label));if(scaleInput)scaleInput.setAttribute('aria-valuetext',scale.label);if(scaleOutput)scaleOutput.textContent=(dialog.dataset.scaleSummary||'[label] · [inches] in').replace('[label]',scale.label).replace('[inches]',String(scale.inches));if(summary)summary.textContent=(sizeButton.dataset.label||'')+' · '+(sizeButton.dataset.price||'')+' · '+scale.label;paintZoom()};const selectSize=(button)=>{sizeButton=button;sizeButtons.forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false')});paint()};sizeButtons.forEach((button)=>button.addEventListener('click',()=>selectSize(button)));if(scaleInput)scaleInput.addEventListener('input',()=>{scaleIndex=Math.max(0,Math.min(scales.length-1,Number(scaleInput.value)||0));paint()});if(zoomOut)zoomOut.addEventListener('click',()=>{zoom=Math.max(1,zoom-.25);paintZoom()});if(zoomIn)zoomIn.addEventListener('click',()=>{zoom=Math.min(3,zoom+.25);paintZoom()});if(zoomReset)zoomReset.addEventListener('click',()=>{zoom=1;paintZoom()});library.addEventListener('click',(event)=>{const button=event.target.closest('[data-open-preview]');if(!button||!library.contains(button))return;const card=button.closest('[data-print-card]');if(!card||!card.dataset.previewUrl)return;current={printId:card.dataset.printId||'',printName:card.dataset.printName||'',previewUrl:card.dataset.previewUrl||''};scaleIndex=3;zoom=1;if(scaleInput)scaleInput.value='3';selectSize(sizeButtons[0]);if(nameEl)nameEl.textContent=current.printName;if(idEl)idEl.textContent=current.printId;if(status)status.textContent='';if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','')});if(closeButton)closeButton.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()});if(addButton)addButton.addEventListener('click',async()=>{if(addButton.disabled||dialog.dataset.orderingEnabled!=='true'||!sizeButton)return;const variantId=Number(sizeButton.dataset.variantId);if(!variantId)return;const scale=selectedScale();addButton.disabled=true;const original=addButton.textContent;addButton.textContent=dialog.dataset.adding||original;if(status)status.textContent='';try{const response=await fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1,properties:{'Print ID':current.printId,'Print':current.printName,'Print Scale':scale.label,'Repeat Width':scale.inches+' in'}}]})});const payload=await response.json();if(!response.ok)throw new Error(payload.description||dialog.dataset.cartError);if(status)status.textContent=dialog.dataset.added||'';window.location.href=rootUrl+'cart'}catch(error){if(status)status.textContent=error&&error.message?error.message:(dialog.dataset.cartError||'');addButton.disabled=false;addButton.textContent=original}});paint()})}
function bootJiuLibrary(root){initializeJiuLibrary(root);initializeJiuPreview(root);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>bootJiuLibrary(document),{once:true});}else{bootJiuLibrary(document);}
document.addEventListener('shopify:section:load',(event)=>bootJiuLibrary(event.target));
window.addEventListener('pageshow',()=>bootJiuLibrary(document));

  } catch(e) { console.error(e); }
})();
})();
